import { useState } from 'react';
import { Button } from '../../r2/Button';
import styles from './AgentPrompt.module.css';

export interface AgentPromptProps {
  onSubmit: (prompt: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function AgentPrompt({
  onSubmit,
  disabled = false,
  placeholder = 'Try: "Build me a feature card" or "Build a hero section"',
}: AgentPromptProps) {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <div
      data-crd-id="r3.bq-agent-prompt"
      data-crd-layer="r3"
      className={styles.container}
    >
      <input
        type="text"
        className={styles.input}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
        placeholder={placeholder}
        disabled={disabled}
      />
      <Button
        variant="primary"
        size="small"
        onClick={handleSubmit}
        disabled={disabled || !value.trim()}
      >
        Build
      </Button>
    </div>
  );
}
